
export default {
    name: 'BusinessAutoQuote',
    props: {
        business: {
            type: Object,
            required: true,
        },
    },
    computed: {
        serviceIds() {
            return this.business.services.map((service) => service.id);
        },
        showBanner() {
            return !this.business.auto_bids.length && (this.showGrabBags || this.showSkips);
        },
        showGrabBags() {
            return this.serviceIds.includes(3);
        },
        showSkips() {
            return this.serviceIds.includes(2);
        },
    },
};
